import { render, staticRenderFns } from "./EventStatistics.vue?vue&type=template&id=123c69fd"
import script from "./EventStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./EventStatistics.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports